module.exports = __webpack_public_path__ + "img/sea of tranquility far side.30b95926.png";